import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  Button,
  HorizontalStack,
  Icon,
  KCol,
  KContentMenu,
  KContentMenuItem,
  KContentMenuPanel,
  KDrawer,
  KPanel,
  KRow,
  KTab,
  KTabItem,
  KTable,
  KTableColumn,
  KTableHeader,
  KTableRow,
  Label,
} from "../../components/web-components";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { KuikaTabOrderProvider } from "../../shared/hoc/tab-order-provider";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withInlineOverlayNav } from "../../shared/hoc/with-inline-overlay-nav";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { UserManagement_ScreenBase } from "./usermanagement-base";

import { InlineFormScope } from "../../routes/master-screen-wrapper";
import { UserCreate_Screen } from "../usercreate/usercreate";
import { UserEdit_Screen } from "../useredit/useredit";
import { UserRoleManagement_Screen } from "../userrolemanagement/userrolemanagement";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class UserManagement_Screen extends UserManagement_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin spinning={this.state.spinnerCount > 0}>
          <KuikaTabOrderProvider>
            <Form
              form={this.props.form}
              name="basic"
              initialValues={{ usermanagement_14735_value: undefined }}
              onValuesChange={(changedValues, allValues) => {
                this.clearFieldValidation(changedValues);
              }}
            >
              <>
                <div
                  key="-1"
                  id="usermanagement_body"
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(244, 244, 244, 1)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "left",
                      display: "block",
                    } as any
                  }
                >
                  <KRow
                    key="689609"
                    id="689609"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <KCol
                      key="732252"
                      id="732252"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <Label
                        key="635194"
                        id="635194"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          635194,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 600,
                            fontSize: "20px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      ></Label>
                    </KCol>
                  </KRow>
                  <KRow
                    key="867088"
                    id="867088"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <KCol
                      key="859928"
                      id="859928"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <KPanel
                        key="921811"
                        id="921811"
                        scrolling="hidden"
                        scrollRadius={false}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                          } as any
                        }
                      >
                        <KRow
                          key="946947"
                          id="946947"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                            } as any
                          }
                        >
                          <KCol
                            key="155281"
                            id="155281"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 8,
                                paddingBottom: 0,
                                paddingLeft: 8,
                                alignItems: "center",
                                textAlign: "-webkit-right",
                              } as any
                            }
                          >
                            <Button
                              key="436352"
                              id="436352"
                              onClick={(e?: any) => {
                                if (e && e.stopPropagation) e.stopPropagation();
                                this.UserManagementComponent_436352_onClick();
                              }}
                              showCursorPointer
                              label={ReactSystemFunctions.translate(
                                this.ml,
                                436352,
                                "label",
                                this.defaultML
                              )}
                              size="middle"
                              loading={false}
                              ghost={false}
                              block={false}
                              htmlType="button"
                              icon="add"
                              iconPosition="left"
                              danger={false}
                              iconLibrary="material"
                              style={
                                {
                                  borderTopLeftRadius: 8,
                                  borderTopRightRadius: 8,
                                  borderBottomRightRadius: 8,
                                  borderBottomLeftRadius: 8,
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  backgroundColor: "rgba(3, 88, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 8,
                                  paddingRight: 16,
                                  paddingBottom: 8,
                                  paddingLeft: 16,
                                  alignItems: "center",
                                  textAlign: "-webkit-center",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "16px",
                                  color: "rgba(255, 255, 255, 1)",
                                  lineHeight: "22px",
                                } as any
                              }
                            ></Button>
                          </KCol>
                        </KRow>
                        <KRow
                          key="575121"
                          id="575121"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                            } as any
                          }
                        >
                          <KCol
                            key="591841"
                            id="591841"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <Form.Item
                              className="kFormItem"
                              name="usermanagement_14735_value"
                              noStyle
                            >
                              <KTab
                                key="14735"
                                id="14735"
                                type="line"
                                size="default"
                                tabPosition="top"
                                selectedTabColor="#0078FF"
                                justifiedTabTitles={false}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "inline",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KTabItem
                                  key={989259}
                                  id="989259"
                                  tab={ReactSystemFunctions.translate(
                                    this.ml,
                                    989259,
                                    "tab",
                                    this.defaultML
                                  )}
                                  forceRender={false}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="679037"
                                    id="679037"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="337310"
                                      id="337310"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KTable
                                        key="777786"
                                        id="777786"
                                        kuikaRef={
                                          this
                                            .usermanagement_777786_value_kuikaTableRef
                                        }
                                        form={this.props.form}
                                        dataSource={
                                          this.state.GetPersonUserManagement
                                        }
                                        size="middle"
                                        bordered={true}
                                        loading={false}
                                        rowKey="id"
                                        transformedOnMobileResolution={false}
                                        hideHeaderOnMobileResolution={false}
                                        showHeader={true}
                                        fixedHeader={false}
                                        tableWidthMode="fit"
                                        editable={false}
                                        editableAlwaysActive={false}
                                        insertRowActive={false}
                                        insertRowPosition="top"
                                        globalSearch={false}
                                        searchable={false}
                                        shouldSearchOnChange={true}
                                        searchDelay={200}
                                        sorter={false}
                                        filtering={false}
                                        resizableColumns={false}
                                        pagination={true}
                                        pageSize={10}
                                        showSizeChanger={false}
                                        paginationSelectedTextColor="#246eff"
                                        paginationUnselectedTextColor="#000"
                                        columnChooser={false}
                                        striped={false}
                                        stripedColor="#F5F7FA"
                                        rowHoverBgColor="#fafafa"
                                        showRowNumbers={false}
                                        showNoDataFound={true}
                                        nodatafoundmessage={ReactSystemFunctions.translate(
                                          this.ml,
                                          777786,
                                          "nodatafoundmessage",
                                          this.defaultML
                                        )}
                                        multiSelect={false}
                                        multiSelectScope="page"
                                        export={false}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 400,
                                            fontSize: "15px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KTableHeader
                                          key="254398"
                                          id="254398"
                                          hideOnMobileResolution={false}
                                          textDirection="Default"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 400,
                                              fontSize: "14px",
                                              color: "rgba(155, 155, 155, 1)",
                                              lineHeight: "20px",
                                            } as any
                                          }
                                        ></KTableHeader>
                                        <KTableRow
                                          key="984779"
                                          id="984779"
                                          hoverFontColor="red"
                                          hoverBgColor="#F5F5F5"
                                          style={
                                            {
                                              borderTopWidth: 1,
                                              borderRightWidth: 1,
                                              borderBottomWidth: 1,
                                              borderLeftWidth: 1,
                                              borderColor:
                                                "rgba(218, 218, 218, 1)",
                                              borderStyle: "solid",
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 400,
                                              fontSize: "15px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KTableColumn
                                            key="426732"
                                            id="426732"
                                            title={ReactSystemFunctions.translate(
                                              this.ml,
                                              426732,
                                              "title",
                                              this.defaultML
                                            )}
                                            alwaysVisibleOnMobileResolution={
                                              false
                                            }
                                            hideFiltering={false}
                                            hideSorting={false}
                                            hideSearch={false}
                                            footerOptions="none"
                                            footerFontSize={14}
                                            footerFontColor="rgb(68, 68, 68)"
                                            excludeFromExport={false}
                                            footerFontWeight="Regular"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "15px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="754899"
                                              id="754899"
                                              value="[datafield:adSoyad]"
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "15px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            ></Label>
                                          </KTableColumn>
                                          <KTableColumn
                                            key="968505"
                                            id="968505"
                                            title={ReactSystemFunctions.translate(
                                              this.ml,
                                              968505,
                                              "title",
                                              this.defaultML
                                            )}
                                            alwaysVisibleOnMobileResolution={
                                              false
                                            }
                                            hideFiltering={false}
                                            hideSorting={false}
                                            hideSearch={false}
                                            footerOptions="none"
                                            footerFontSize={14}
                                            footerFontColor="rgb(68, 68, 68)"
                                            excludeFromExport={false}
                                            footerFontWeight="Regular"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "15px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="745872"
                                              id="745872"
                                              value="[datafield:kullaniciAdi]"
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "15px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            ></Label>
                                          </KTableColumn>
                                          <KTableColumn
                                            key="441245"
                                            id="441245"
                                            title={ReactSystemFunctions.translate(
                                              this.ml,
                                              441245,
                                              "title",
                                              this.defaultML
                                            )}
                                            alwaysVisibleOnMobileResolution={
                                              false
                                            }
                                            hideFiltering={false}
                                            hideSorting={false}
                                            hideSearch={false}
                                            footerOptions="none"
                                            footerFontSize={14}
                                            footerFontColor="rgb(68, 68, 68)"
                                            excludeFromExport={false}
                                            footerFontWeight="Regular"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "15px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="802560"
                                              id="802560"
                                              value="[datafield:sifre]"
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "15px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            ></Label>
                                          </KTableColumn>
                                          <KTableColumn
                                            key="992229"
                                            id="992229"
                                            title={ReactSystemFunctions.translate(
                                              this.ml,
                                              992229,
                                              "title",
                                              this.defaultML
                                            )}
                                            alwaysVisibleOnMobileResolution={
                                              false
                                            }
                                            hideFiltering={false}
                                            hideSorting={false}
                                            hideSearch={false}
                                            footerOptions="none"
                                            footerFontSize={14}
                                            footerFontColor="rgb(68, 68, 68)"
                                            excludeFromExport={false}
                                            footerFontWeight="Regular"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "15px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="359068"
                                              id="359068"
                                              value="[datafield:magaza]"
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "15px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            ></Label>
                                          </KTableColumn>
                                          <KTableColumn
                                            key="675828"
                                            id="675828"
                                            title={ReactSystemFunctions.translate(
                                              this.ml,
                                              675828,
                                              "title",
                                              this.defaultML
                                            )}
                                            alwaysVisibleOnMobileResolution={
                                              false
                                            }
                                            hideFiltering={false}
                                            hideSorting={false}
                                            hideSearch={false}
                                            footerOptions="none"
                                            footerFontSize={14}
                                            footerFontColor="rgb(68, 68, 68)"
                                            excludeFromExport={false}
                                            footerFontWeight="Regular"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                width: "100px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "15px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <HorizontalStack
                                              key="488090"
                                              id="488090"
                                              direction="horizontal"
                                              size={12}
                                              overflowX="auto"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "15px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <Icon
                                                key="867641"
                                                id="867641"
                                                visibility={
                                                  this.state.isComp867641Visible
                                                }
                                                visibilityCondition={(
                                                  rowData: object
                                                ) =>
                                                  ReactSystemFunctions.isEqualTo(
                                                    rowData.rolVarMi,
                                                    "0"
                                                  )
                                                }
                                                iconLibrary="material"
                                                iconName="cancel"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "24px",
                                                    color:
                                                      "rgba(225, 60, 57, 1)",
                                                    letterSpacing: "1px",
                                                  } as any
                                                }
                                              ></Icon>
                                              <Icon
                                                key="62415"
                                                id="62415"
                                                visibility={
                                                  this.state.isComp62415Visible
                                                }
                                                visibilityCondition={(
                                                  rowData: object
                                                ) =>
                                                  ReactSystemFunctions.isEqualTo(
                                                    rowData.rolVarMi,
                                                    "1"
                                                  )
                                                }
                                                iconLibrary="material"
                                                iconName="check_circle"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "24px",
                                                    color:
                                                      "rgba(114, 194, 64, 1)",
                                                    letterSpacing: "1px",
                                                  } as any
                                                }
                                              ></Icon>
                                            </HorizontalStack>
                                          </KTableColumn>
                                          <KTableColumn
                                            key="320923"
                                            id="320923"
                                            title={ReactSystemFunctions.translate(
                                              this.ml,
                                              320923,
                                              "title",
                                              this.defaultML
                                            )}
                                            alwaysVisibleOnMobileResolution={
                                              false
                                            }
                                            hideFiltering={false}
                                            hideSorting={false}
                                            hideSearch={false}
                                            footerOptions="none"
                                            footerFontSize={14}
                                            footerFontColor="rgb(68, 68, 68)"
                                            excludeFromExport={false}
                                            footerFontWeight="Regular"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                width: "100px",
                                                alignItems: "center",
                                                textAlign: "-webkit-center",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "15px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KContentMenu
                                              key="46282"
                                              id="46282"
                                              menuOpeningType="hover"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "15px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KContentMenuPanel
                                                key="731291"
                                                id="731291"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "15px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="776435"
                                                  id="776435"
                                                  iconLibrary="material"
                                                  iconName="more_vert"
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(68, 142, 247, 1)",
                                                      paddingTop: 4,
                                                      paddingRight: 4,
                                                      paddingBottom: 4,
                                                      paddingLeft: 4,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "24px",
                                                      color:
                                                        "rgba(255, 255, 255, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                              </KContentMenuPanel>
                                              <KContentMenuItem
                                                key="210976"
                                                id="210976"
                                                onClick={(e?: any) => {
                                                  if (e && e.stopPropagation)
                                                    e.stopPropagation();
                                                  this.UserManagementComponent_210976_onClick();
                                                }}
                                                showCursorPointer
                                                label={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  210976,
                                                  "label",
                                                  this.defaultML
                                                )}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "15px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></KContentMenuItem>
                                              <KContentMenuItem
                                                key="209933"
                                                id="209933"
                                                onClick={(e?: any) => {
                                                  if (e && e.stopPropagation)
                                                    e.stopPropagation();
                                                  this.UserManagementComponent_209933_onClick();
                                                }}
                                                showCursorPointer
                                                label={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  209933,
                                                  "label",
                                                  this.defaultML
                                                )}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "15px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></KContentMenuItem>
                                            </KContentMenu>
                                          </KTableColumn>
                                        </KTableRow>
                                      </KTable>
                                    </KCol>
                                  </KRow>
                                </KTabItem>
                              </KTab>
                            </Form.Item>
                          </KCol>
                        </KRow>
                      </KPanel>
                    </KCol>
                  </KRow>
                  <KDrawer
                    key="150174"
                    id="150174"
                    placement="right"
                    onClose={() => {
                      this.setState({ NavVisible150174: false }, () => {
                        this.callCallbackFunction(150174);
                      });
                    }}
                    visible={this.state.NavVisible150174}
                    width="75%"
                    height="100vh"
                    push={true}
                    closable={true}
                    children={
                      this.state.NavVisible150174 && (
                        <InlineFormScope>
                          <UserCreate_Screen
                            onClose={() => {
                              this.setState({ NavVisible150174: false }, () => {
                                this.callCallbackFunction(150174);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  ></KDrawer>
                  <KDrawer
                    key="37195"
                    id="37195"
                    placement="right"
                    onClose={() => {
                      this.setState({ NavVisible37195: false }, () => {
                        this.callCallbackFunction(37195);
                      });
                    }}
                    visible={this.state.NavVisible37195}
                    width="75%"
                    height="100vh"
                    push={true}
                    closable={true}
                    children={
                      this.state.NavVisible37195 && (
                        <InlineFormScope>
                          <UserEdit_Screen
                            onClose={() => {
                              this.setState({ NavVisible37195: false }, () => {
                                this.callCallbackFunction(37195);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  ></KDrawer>
                  <KDrawer
                    key="315409"
                    id="315409"
                    placement="right"
                    onClose={() => {
                      this.setState({ NavVisible315409: false }, () => {
                        this.callCallbackFunction(315409);
                      });
                    }}
                    visible={this.state.NavVisible315409}
                    width="75%"
                    height="100vh"
                    push={true}
                    closable={true}
                    children={
                      this.state.NavVisible315409 && (
                        <InlineFormScope>
                          <UserRoleManagement_Screen
                            onClose={() => {
                              this.setState({ NavVisible315409: false }, () => {
                                this.callCallbackFunction(315409);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  ></KDrawer>
                </div>
              </>
            </Form>
          </KuikaTabOrderProvider>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          withInlineOverlayNav(
            connect(mapStateToProps, mapDispatchToProps)(UserManagement_Screen)
          )
        )
      )
    )
  )
);
export { tmp as UserManagement_Screen };
//export default tmp;
//export { tmp as UserManagement_Screen };
